import { Avatar, Box, Text } from 'components'
import { getInitials } from 'helpers'
import { useArcTranslation } from 'hooks'
import type { MemberAvatarGroupProps } from '../interfaces'
import { MAX_VISIBLE_AVATARS } from '../constants'

/** Labeled, overflow-aware avatar row built from member names (initials only). */
export const MemberAvatarGroup = ({ members, label, emptyLabel }: MemberAvatarGroupProps) => {
  const { t } = useArcTranslation()
  const total = members.length
  const overflow = total - MAX_VISIBLE_AVATARS

  return (
    <Box>
      <Text size='xs' color='dimmed' tt='uppercase'>
        {total > 0 ? `${label} (${total})` : label}
      </Text>

      {total === 0 ? (
        <Text size='sm' color='dimmed'>
          {emptyLabel ?? '—'}
        </Text>
      ) : (
        <Avatar.Group spacing='sm' aria-label={label}>
          {members.slice(0, MAX_VISIBLE_AVATARS).map(member => (
            <Avatar key={member.id} size='md' radius='xl' alt={member.name}>
              {getInitials(member.name)}
            </Avatar>
          ))}
          {overflow > 0 && (
            <Avatar
              size='md'
              radius='xl'
              color='gray'
              aria-label={t('manager_dashboard.more_members', { count: overflow })}
            >
              +{overflow}
            </Avatar>
          )}
        </Avatar.Group>
      )}
    </Box>
  )
}
